import { TableCellRenderer } from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

export interface PaymentCardDropTableProps {
  Button?: TableCellRenderer;
}

/**
 * Payment card Drop table columns
 */
export const paymentCardDropTableColumns = (params: PaymentCardDropTableProps): CustomTableColumn[] => {
  const transactionColumn: CustomTableColumn[] = [
    globalTableColumns.id({
      width: 125,
      show: true
    }),
    globalTableColumns.standardText({
      Header: "Drop Number",
      accessor: "branchNumber"
    }),
    globalTableColumns.standardText({
      Header: "Name",
      accessor: "name",
      width: 250
    }),
    globalTableColumns.standardText({
      Header: "Address",
      sortable: false,
      accessor: "address.addressLine1"
    }),
    globalTableColumns.status(),
    globalTableColumns.actions({
      width: 100,
      cell: params.Button
    })
  ];

  return transactionColumn;
};
